<template>
  <div class="bar-container flex-row justify-content-start align-items-center"
       :style="{ backgroundImage: 'url('+ backImg +')'}">
    <div class="flex-column justify-content-center align-items-center bar-left"
         style="height: 100%;padding-left: 0.3rem;width: 1rem">
      <!--        <div class="right-image" style="width: 0.6rem;height: 0.6rem"-->
      <!--             @click="eback"-->
      <!--             :style="{ backgroundImage: 'url('+ rightImage +')'}"></div>-->
      <i
          v-if="showBack"
          class="el-icon-arrow-left right-image"
          style="width: 0.5rem;height: 0.5rem;font-size: 0.6rem"
          @click="eback"></i>
    </div>
    <div class="flex-column justify-content-center align-items-center"
         style="height: 100%;;width: calc(100% - 2rem)">
      <i class="title" style="color: #fff">{{ title }}</i>
    </div>
    <div class="flex-column justify-content-center align-items-center"
         style="height: 100%;padding-right: 0.3rem;width: 1rem">
      <div class="right-image" style="width: 0.5rem;height: 0.5rem"
           @click="mrightClick"
           :style="{ backgroundImage: 'url('+ rightImage +')'}"></div>
    </div>
  </div>
</template>

<script>
import top from "@/assets/home_new/onTheGo/top.png";

export default {
  name: "topBar",
  components: {},
  props: {
    title: {
      type: String,
      default: "蒙青E家"
    },
    backImg: {
      type: Object,
      default: top
    },
    rightImage: {
      type: Object,
      default: null
    },
    showBack: {
      type: Boolean,
      default: false
    },
    back: {
      type: Function,
      default: undefined
    },
    rightClick: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      route: {},
      top: top,
    };
  },
  created() {
    this.route = this.$route.query;
    console.log(this.backImg)
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    eback() {
      console.log(2)
      console.log(this.back)
      if (this.back) {
        this.$emit("back");
        return
      }
      this.$router.go(-1);
    },
    mrightClick() {
      this.$emit("rightClick");
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";

.bar-container {
  color: #ffffff;
  display: flex;
  height: 1.44rem;
  width: 100vw;
  font-size: 0.36rem;
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.right-image {
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.bar-left {
  left: 20px;
  width: 0.4rem;
  height: 1.44rem
}

.bar-title {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: calc(100% - 1.32rem);
  padding-left: 0.2rem;
}

.bar-right {
  position: fixed;
  display: block;
  top: 0;
  right: 20px;
  width: 0.4rem;
  height: 1.44rem;
}
</style>
